import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';
export const BBPS_COMPLAINT_UPDATE_FORM_CONFIG = [
  {
    key: 'status',
    name: 'status',
    label: 'Status',
    placeholder: 'Select Status',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    options: [
      { value: 'CREATED', label: 'Created' },
      { value: 'SUBMITTED', label: 'Submitted' },
      { value: 'RESOLVED', label: 'Resolved' },
    ],
    isEditable: true,
    isRequired: true
  },
  {
    key: 'resolutionNotes',
    name: 'resolutionNotes',
    label: 'Resolution Notes',
    placeholder: 'Enter resolution notes',
    fieldType: INPUT_FIELD_TYPE.TEXTAREA,
    isEditable: true,
    isRequired: false
  }
];
